__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-06-24-1782305488-stable-dev/";